// extracted by mini-css-extract-plugin
module.exports = {"discoverAdsText":"DriveSuccess_discoverAdsText__35Lvb","subHeading":"DriveSuccess_subHeading__24-72"};